import {
  mdiAccountMultipleOutline,
  mdiFileDocumentMultipleOutline,
  mdiEarth,
  mdiSchool,
  mdiFormatListBulleted,
  mdiEarthPlus,
  mdiMapSearchOutline,
  mdiFileChartOutline
} from '@mdi/js'

export default [

  // { title: 'common.home', icon: mdiHomeOutline, to: 'home' },
  { title: 'common.statistics', icon: mdiFormatListBulleted, to: 'statistics' },
  { title: 'common.reports', icon: mdiFileChartOutline, to: 'reports' },
  {subheader: 'common.eval_subheader' },
  { title: 'common.qip', icon: mdiFileDocumentMultipleOutline, to: 'evaluations' },
  // { title: 'Resultados', icon: mdiChartBar, to: 'results' },
  {subheader: '' },
  { title: 'common.users', icon: mdiAccountMultipleOutline, to: 'users' },
  { title: 'common.schools', icon: mdiSchool, to: 'schools' },
  { title: 'common.countries', icon: mdiEarth, to: 'countries' },
  { title: 'common.zones', icon: mdiMapSearchOutline, to: 'zones' },
  { title: 'common.regions', icon: mdiEarthPlus, to: 'regions' },
  // {subheader: 'FAQs' },
  // { title: 'Tutorial', icon: mdiVideoVintage, to: 'tutorial' },

]
